'use client';

import { useEffect, useRef } from 'react';

import { superScriptify } from '../RichText/RichTextComponent';
import { vercelStegaSplit } from '@vercel/stega';

export function StegaClean({
	value,
	superScriptClass,
}: {
	value?: string | null;
	superScriptClass?: string;
}) {
	const elementRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		if (elementRef.current) {
			const parentElement = elementRef.current.parentElement;
			parentElement?.setAttribute('data-sanity-edit-target', 'true');
		}
	}, []);

	if (!value) {
		return <></>;
	}
	const { cleaned, encoded } = vercelStegaSplit(value);

	return (
		<>
			{superScriptify(cleaned, superScriptClass)}
			{encoded && (
				<span ref={elementRef} style={{ display: 'none' }}>
					{encoded}
				</span>
			)}
		</>
	);
}
